import throttle from "lodash.throttle";
import { Scope } from "@/wbcontroller/types/Scope";

export default class ThrottledUpsertController {
  immediateFunction: (scope: Scope) => void;
  throttledFunction: { cancel: () => void } & ((scope: Scope) => void);

  constructor(immediateFunction: (scope: Scope) => void) {
    this.immediateFunction = immediateFunction;
    this.throttledFunction = throttle(immediateFunction, 300, {
      leading: true,
    });
  }

  call() {
    this.throttledFunction(Scope.Live);
    this.immediateFunction(Scope.Local);
  }

  cancel() {
    this.throttledFunction.cancel();
  }
}
